import {
  ExcelExportOptionsEvent
} from '@app/pcs/shared/export-options/excel-export-options/excel-export-options-event';
import { Action } from '@ngrx/store';

export enum ExportDossierSearchResultsActionTypes {
  ExportDossierSearchResults = '[DossierSearchResultsExport] Export Dossier Search Results',
  ExportDossierSearchResultsFail = '[DossierSearchResultsExport] Export Dossier Search Results Fail'
}

export class ExportDossierSearchResults implements Action {
  readonly type = ExportDossierSearchResultsActionTypes.ExportDossierSearchResults;

  constructor(public payload: ExcelExportOptionsEvent) {
  }
}

export class ExportDossierSearchResultsFail implements Action {
  readonly type = ExportDossierSearchResultsActionTypes.ExportDossierSearchResultsFail;

  constructor(public payload: Error) {
  }
}
